import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import "rxjs/add/operator/toPromise";
import "rxjs/add/observable/of";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs/Observable";
import { catchError, tap } from "rxjs/operators";
import { ErrorObservable } from "rxjs/observable/ErrorObservable";
import { Dashreport } from "./dashreport.model";
import { CognitoService } from "../../services/cognito/cognito.service";
import { AwsSignerService } from "../../services/aws-signer/aws-signer.service";
import { Encoder } from "../../utils/encoder";
import { DashreportListResponse } from "./dashreport-list-reponse.model";

@Injectable()
export class DashreportService {
  hasJustRegistered: boolean;
  hasJustUpdated: boolean;

  constructor(
    private http: HttpClient,
    private cognitoService: CognitoService,
    private awsSignerService: AwsSignerService
  ) {
    this.hasJustRegistered = false;
    this.hasJustUpdated = false;
  }

  exportExcel(params): Observable<any> {
    console.log(params);
    let url = this.getUrl() + "/export";
    if (params && params.startDate && params.endDate) {
      url += `?startDate=${params.startDate}&endDate=${params.endDate}`;
    }
    if (params && params.searcheValue ) {
      const queryParam = `query=${params.searcheValue}`;
      url += url.includes("?") ? `&${queryParam}` : `?${queryParam}`;
    }
    const awsHeaders = this.awsSignerService.getAwsHeader(url, "GET");
    const headerParams = {
      "Content-Type": "application/json",
      Authorization: awsHeaders["Authorization"],
      "X-Amz-Date": awsHeaders["X-Amz-Date"],
      "x-amz-security-token": awsHeaders["x-amz-security-token"],
      "x-api-key": environment.cesAPI.apiKey,
    };
    const httpOptions = {
      headers: new HttpHeaders(headerParams),
      responseType: 'text' as 'json'
    }

    return this.http
      .get<any>(url, httpOptions)
      .pipe(catchError((err) => this.handleError(err)));
  }

  getDashReportList(params): Observable<any> {
    console.log(params);
    let url = this.getUrl();
    if (params && params.startDate && params.endDate) {
      url += `?startDate=${params.startDate}&endDate=${params.endDate}`;
    }

    const awsHeaders = this.awsSignerService.getAwsHeader(url, "GET");

    const headerParams = {
      "Content-Type": "application/json",
      Authorization: awsHeaders["Authorization"],
      "X-Amz-Date": awsHeaders["X-Amz-Date"],
      "x-amz-security-token": awsHeaders["x-amz-security-token"],
      "x-api-key": environment.cesAPI.apiKey,
    };
    const httpOptions = {
      headers: new HttpHeaders(headerParams),
    };

    return this.http
      .get<any>(url, httpOptions)
      .pipe(catchError((err) => this.handleError(err)));
  }

  private getUrl() {
    return `${localStorage.getItem("region-api")}/v1/datamart/manage/report`;
  }

  private handleError(error: HttpErrorResponse) {
    if (
      error.error.error &&
      error.error.error.message ===
        "The security token included in the request is expired"
    ) {
      this.cognitoService.logout();
      return;
    }
    if (error.error.error && error.error.error.message) {
      return new ErrorObservable(error.error.error.message);
    }
    if (error.error.error instanceof ErrorEvent) {
      // A provider-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.error.status}, ` + `body was: ${error.error.error}`
      );
    }
    // return an ErrorObservable with a user-facing error message
    return new ErrorObservable(
      "Something bad happened. Please try again later."
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashreport/dashreport.service.ts